<template>
  <el-dialog
    title="添加进出口管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >

        <el-form-item label="选择企业" prop="enterprise_id">
          <el-select
            v-model="form.enterprise_id"
            filterable
            placeholder="请选择企业"
            style="width: 100%"
            :loading="loadingEnterprises"
          >
            <el-option
              v-for="enterprise in enterpriseList"
              :key="enterprise.supply_id"
              :label="enterprise.name"
              :value="enterprise.supply_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="负责人姓名" prop="charge_name">
          <el-input
            v-model="form.charge_name"
            placeholder="请输入负责人姓名"
            class="max-w460"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="负责人电话" prop="charge_phone">
          <el-input
            v-model="form.charge_phone"
            placeholder="请输入负责人电话"
            class="max-w460"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="所属分类" prop="category">
          <el-select
            v-model="form.category"
            placeholder="请选择所属分类"
            class="max-w460"
            @change="handleCategoryChange"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 进出口产品相关字段 -->
        <div v-if="form.category === 5">
          <el-form-item label="贸易类型" prop="trade_type">
            <el-radio-group v-model="form.trade_type">
              <el-radio :label="0">进口</el-radio>
              <el-radio :label="1">出口</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="产品名称" prop="product_name">
            <el-input
              v-model="form.product_name"
              placeholder="请输入产品名称"
              class="max-w460"
            ></el-input>
          </el-form-item>
          
          <el-form-item 
            :label="form.trade_type === 0 ? '原产国' : '生产国'" 
            prop="origin_country"
          >
            <el-input
              v-model="form.origin_country"
              placeholder="请输入国家名称"
              class="max-w460"
            ></el-input>
          </el-form-item>
          
          <el-form-item 
            :label="form.trade_type === 0 ? '目标市场' : '出口国家'" 
            prop="target_country"
          >
            <el-input
              v-model="form.target_country"
              placeholder="请输入国家名称"
              class="max-w460"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="进出口管理图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="进出口管理介绍">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      
      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Import_export_manageApi from "@/api/import_export_manage.js";
import EnterpriseApi from "@/api/enterprise.js";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      loadingEnterprises:false,
      enterpriseList:[],
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        enterprise_id:null,
        category: "",
        name: "",
        code: "custom",
        image: [],
        // categorya:{},
        sort: 50,
        intro: "",
       
        bannar: []
      },
      categoryOptions: [
        { value: 0, label: "国家宣传" },
        // { value: 1, label: "物流板块" },
        // { value: 2, label: "金融" },
        // { value: 3, label: "报关" },
        // { value: 4, label: "商旅考察" },
         { value: 5, label: "进出口产品" }
      ],
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          // { required: true, message: "请输入进出口管理名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.addenterPriseList();
  },
  props: ["open_add"],
  methods: {
    addenterPriseList() {
      var self = this;

      EnterpriseApi.listx({}, true)
        .then(data => {
          self.loading = false;
          self.enterpriseList = data.data.list;
          console.log("enterpriseList", self.enterpriseList);
        })
        .catch(error => {});
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.enterprise = form.supply_id;

      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Import_export_manageApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/import_export_manage/index/part/add.vue